import _styled, { css as _css, default as _styled2, default as _styled3 } from "styled-components";
import React from "react";
import CaretDown from "~/public/icons/caret-down.svg";
import { Icon } from "~/features/ui/icon";
const bounce = /*#__PURE__*/_css(["display:inline-flex;@keyframes heroDiscoverBounce{0%,100%{transform:translateY(0);}50%{transform:translateY(2px);}}@media (prefers-reduced-motion:no-preference){animation:heroDiscoverBounce 1s ease-in-out infinite;}"]);
type Props = {
  /** Ref to the hero root element; the button scrolls its next sibling into view. */
  rootRef: React.RefObject<HTMLElement | null>;
  className?: string;
  label?: string;
};

/**
 * Shared "Discover more" scroll indicator used across heroes. Smooth-scrolls to
 * the element after the hero root (falls back to one viewport down), with a
 * bouncing down-chevron that respects prefers-reduced-motion.
 */
export function DiscoverMore({
  rootRef,
  className,
  label = "Discover more"
}: Props) {
  const handleClick = () => {
    const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
    const next = rootRef.current?.nextElementSibling;
    if (next) next.scrollIntoView({
      behavior,
      block: "start"
    });else window.scrollTo({
      top: window.innerHeight,
      behavior
    });
  };
  return <_StyledButton type="button" onClick={handleClick} aria-label="Scroll to next section" className={className} $_css2={[{
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "gap": "0.8rem",
    "color": "currentColor",
    "transitionProperty": "opacity",
    "transitionDuration": "500ms",
    "&:hover": {
      "opacity": "0.7"
    }
  }]}>
      <_StyledSpan>{label}</_StyledSpan>
      <_StyledSpan2>
        <Icon icon={CaretDown} size="16" />
      </_StyledSpan2>
    </_StyledButton>;
}
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  componentId: "sc-sf-1m7l1uh-0"
})`${p => p.$_css2}`;
var _StyledSpan = _styled2("span").withConfig({
  componentId: "sc-sf-1m7l1uh-1"
})({
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.014000000000000002rem",
    "fontWeight": "400"
  }
});
var _StyledSpan2 = /*#__PURE__*/_styled3("span").withConfig({
  displayName: "discover-more___StyledSpan2",
  componentId: "sc-18auuax-0"
})(["", ""], bounce);